import type { SortAllowedStatesColumn } from '@library/types/allowedStates';
import type { SortGameModesColumn } from '@library/types/gameModes';
import type { SortGameTypeColumn } from '@library/types/gameTypes';
import type { SortPlayersColumn } from '@library/types/player';
import type { SortStatTypeColumn } from '@library/types/statType';
import type { SortTeamColumns } from '@library/types/teams';
import type { SortedPromotionsColumn } from '@library/types/promotions';

export const DEFAULT_PLAYER_SORT: SortPlayersColumn = {
  sortBy: 'id',
  sortDirection: 'desc'
};

export const DEFAULT_STAT_TYPE_SORT: SortStatTypeColumn = {
  sortBy: 'id',
  sortDirection: 'desc'
};

export const DEFAULT_GAME_TYPE_SORT: SortGameTypeColumn = {
  sortBy: 'id',
  sortDirection: 'desc'
};

export const DEFAULT_PROMOTION_LIST_SORT: SortedPromotionsColumn = {
  sortBy: 'created_at',
  sortDirection: 'desc'
};

export const DEFAULT_ALLOWED_STATES_SORT: SortAllowedStatesColumn = {
  sortBy: 'id',
  sortDirection: 'desc'
};

export const DEFAULT_GAME_MODE_SORT: SortGameModesColumn = {
  sortBy: 'id',
  sortDirection: 'desc'
};

export const DEFAULT_TEAM_SORT: SortTeamColumns = {
  sortBy: 'id',
  sortDirection: 'desc'
};
